const REGEX_CHECK_FOR_COJP = /\.co\.jp$/i;

export type ViewportDimensions = { height: number, width: number };

/**
 * Class that holds reference to relevant environment constiables/configs
 * See bb.browser
 */
export default class Environment {

    /**
     * Get the height of the viewport
     */
    static getViewportDimensions(): ViewportDimensions {

        if (!(window && document)) {
            return { height: 0, width: 0 };
        }

        const height = window.innerHeight || document.documentElement.clientHeight;
        const width = window.innerWidth || document.documentElement.clientWidth;

        return { height, width };
    }

    /**
     * Query browser policy permission to access window.localStorage
     */
    static localStorageExists(): Storage | null {
        try {
            return window.localStorage;
        } catch (error) {
            return null;
        }
    }

    /**
     * Query browser policy permission to access window.sessionStorage
     */
    static sessionStorageExists(): Storage | null {
        try {
            return window.sessionStorage;
        } catch (error) {
            return null;
        }
    }

    /**
     * Query support for cookies
     */
    static cookiesAreEnabled(): boolean {
        return (window && window.navigator) ? window.navigator.cookieEnabled : false;
    }

    /**
     * Query if domain is co.jp
     */
    static isCOJP(): boolean {
        return REGEX_CHECK_FOR_COJP.test(window.location.hostname);
    }

    /**
     * Query for the existance of the window global
     */
    static isBrowser(): boolean {
        return Boolean(window);
    }

    /**
     * Get the current time
     */
    static currentTime(): DOMHighResTimeStamp {
        if (window.performance && window.performance.now) {
            return window.performance.now();
        }

        return Date.now();
    }

    static getElementStyleAttribute(element: HTMLElement, attribute: string): string {
        return window.getComputedStyle(element).getPropertyValue(attribute);
    }

}
